import { Button } from 'react-bootstrap';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';

import TimePeriodFilingsFilter from './TimePeriodFilingsFilter';
import SourceFilingsDropdown from './SourceFilingsDropdown';
import CategoriesFilingsDropdown from './CategoriesFilingsDropdown';
import ExpandFilings from './ExpandFilings';
import withComponentName from '../../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const ProviderFilter = ({
  isFilterOpen,
  isReset,
  onReset,
  hasSourceAccess,
  isSourceReset,
  isCategoryReset,
  handleFilterClose,
  piwikEnabled,
}) => {
  const providerFilterClass = cx('provider_filter', { active: isFilterOpen });

  return (
    <div className={providerFilterClass}>
      <div
        className={cx('story-filter__close-btn')}
        onClick={handleFilterClose}
      >
        <FontAwesomeIcon icon={faXmark} />
      </div>
      <TimePeriodFilingsFilter isReset={isReset} piwikEnabled={piwikEnabled} />
      {hasSourceAccess && (
        <SourceFilingsDropdown
          isReset={isReset}
          isSourceReset={isSourceReset}
          piwikEnabled={piwikEnabled}
        />
      )}
      <CategoriesFilingsDropdown
        isReset={isReset}
        isCategoryReset={isCategoryReset}
        piwikEnabled={piwikEnabled}
      />
      <ExpandFilings isReset={isReset} piwikEnabled={piwikEnabled} />
      <Button className={Styles.provider_filter_reset} onClick={onReset} variant="default">
        <span>Reset</span>
      </Button>
    </div>
  );
};

export default withComponentName(ProviderFilter);
